import type {
    ViewStyle
} from "react-native";
import type {
    ItemGroupDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const useStyles = ({
    shapeConfigs,
    isDivided,
    radiuses,
    borders,
    variant,
    colors,
    spaces
}: ItemGroupDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(variant === "plain" && !isDivided) {
        styles.container.gap = spaces.spacingXs;
    }

    if(variant === "outline") {
        Object.assign(styles.container, getCornerStyle({
            radius: radiuses.surface,
            shapeConfigs
        }), {
            borderColor: colors.content.border.subtle,
            borderWidth: borders.line,
            borderStyle: "solid",
            overflow: "hidden"
        });
    }

    return styles;
};
